import PropTypes from 'prop-types'
import React from 'react'
import { AdminProvider } from './adminContext'
import { SelectedBranchProvider } from './branchContext'
import { ChartProvider } from './chartContext'

import { LoginModalProvider } from './loginModalContext'
import { MenuProvider } from './menuContext'
import { NotificationsProvider } from './notificationsContext'
import { RangeDateProvider } from './rangeDateContext'
import { ReferralProvider } from './referralContext'
import { SelectedTableBranchProvider } from './tableBranchContext'
import { TableRowsProvider } from './tableRowsContext'
import { UserProvider } from './userContext'

const Compose = ({ Providers, children }) => {
  return Providers.reduce((acc, Provider) => React.createElement(Provider, null, acc), children)
}

export const CombinedProviders = ({ children }) => (
  <Compose
    Providers={[
      LoginModalProvider,
      RangeDateProvider,
      SelectedTableBranchProvider,
      TableRowsProvider,
      UserProvider,
      SelectedBranchProvider,
      ChartProvider,
      MenuProvider,
      NotificationsProvider,
      AdminProvider,
      ReferralProvider
    ]}
  >
    {children}
  </Compose>
)

CombinedProviders.propTypes = {
  children: PropTypes.element.isRequired
}
